import { createBrowserRouter, Navigate } from 'react-router-dom';
import { PublicLayout } from '../layouts/PublicLayout';
import { AdminLayout } from '../layouts/AdminLayout';
import { RequireAdmin, RequireUser } from './guards';
import { HomePage } from '../pages/home/HomePage';
import { LoginPage } from '../pages/auth/LoginPage';
import { EventDetailPage } from '../pages/events/EventDetailPage';
import { RequestFormPage } from '../pages/requests/RequestFormPage';
import { AdminLoginPage } from '../pages/admin/AdminLoginPage';
import { EventSection } from '../pages/admin/sections/EventSection';
import { RequestSection } from '../pages/admin/sections/RequestSection';
import { FilesSection } from '../pages/admin/sections/FilesSection';
import { TypeSection } from '../pages/admin/sections/TypeSection';

export const router = createBrowserRouter([
    {
        element: <PublicLayout />,
        children: [
            { path: '/', element: <HomePage /> },
            { path: '/login', element: <LoginPage /> },
            { path: '/event/:id', element: <EventDetailPage /> },
            {
                path: '/form',
                element: (
                    <RequireUser>
                        <RequestFormPage />
                    </RequireUser>
                ),
            },
        ],
    },
    { path: '/admin/login', element: <AdminLoginPage /> },
    {
        path: '/admin',
        element: (
            <RequireAdmin>
                <AdminLayout />
            </RequireAdmin>
        ),
        children: [
            { index: true, element: <Navigate to="/admin/events" replace /> },
            { path: 'events', element: <EventSection /> },
            { path: 'requests', element: <RequestSection /> },
            { path: 'types', element: <TypeSection /> },
            { path: 'files', element: <FilesSection /> },
        ],
    },
    { path: '*', element: <Navigate to="/" replace /> },
]);
